// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__35Fpu","cell":"ColumnAccessor_cell__nWvuO","firstCellAccent":"ColumnAccessor_firstCellAccent__1S7kv"};